module.exports = __webpack_public_path__ + "img/open-new-account.eefc865.svg";